// Enums
export enum TailType {
  Module = 0,
  Integration = 1,
  Link = 2
}

export enum Modules {
  None = 0,
  Mail = 1,
  Calendar = 2,
  Disk = 3,
  Admin = 4,
  Draw = 5,
  Commands = 6, // Obsolete
  Payments = 7,
  Contacts = 8,
  Team = 9,
  Projects = 10,
  Pages = 11,
  Forms = 12
}

export enum AccessType {
  Deny = -4096,
  OnlyUpload = -1024,
  FreeBusy = -64,
  CanDownload = -16,
  Read = 0,
  Comment = 1,
  Review = 2,
  Write = 4,
  Delete = 8,
  FullInternal = 256,
  Full = 512,
  Lock = 4096,
  LockPrint = 8192,
  LockCopy = 16384,
  LockDownload = 32768,
  Guest = 65536
}

// DTOs
export interface MenuTailShortModel {
  Id: number;
  TitleRu: string;
  TitleEn: string;
  TailType: TailType;
  Modules: Modules;
  IconUrl: string;
}

export interface MenuTailFullModel {
  Id: number;
  TailType: TailType;
  Module: Modules;
  Order: number;
  TitleRu: string;
  TitleEn: string;
  CustomerId: number;
  RedirectUrl: string;
  IconUrl: string;
}

export interface UpsertMenuTailRequest {
  TitleRu: string;
  TitleEn: string;
  CustomerId: number;
  Url: string;
  Module: Modules;
  TailType: TailType;
  IconBase64?: string; // Optional - not required for system modules/integrations
}

export interface UpdateMenuTailRequest {
  TitleRu?: string;
  TitleEn?: string;
  CustomerId?: number;
  Url?: string;
  Module?: Modules;
  TailType?: TailType;
  IconFileId?: number;
  IconBase64?: string;
}

export interface MenuTailOrder {
  TailId: number;
  Order: number;
}

export interface GrantMenuTailAccessRequest {
  RoleIds: number[];
  UserIds: number[];
  AccessType: AccessType;
}

export interface RevokeMenuTailAccessRequest {
  RoleIds: number[];
  UserIds: number[];
}

export interface AccessItemDto {
  Id: number;
  AccessType: AccessType;
}

export interface AccessRightsResponse {
  EntityId: number;
  EntityType: EntityTypes;
  Roles: AccessItemDto[];
  Users: AccessItemDto[];
}

export enum EntityTypes {
  MenuTail = 53
}

// API Wrapper types
export interface ApiResponseWrapper<T> {
  Status: number;
  StatusCode: number;
  Response: T;
}

export interface ApiResponseItem<T> {
  TypeName: string;
  Data: T;
}

// API Response types
export interface GetMenuTailsResponse {
  Status: number;
  StatusCode: number;
  Response: ApiResponseItem<MenuTailShortModel>[];
}

export interface GetMenuTailResponse {
  Status: number;
  StatusCode: number;
  Response: ApiResponseItem<MenuTailFullModel>;
}

export interface CreateMenuTailResponse {
  Status: number;
  StatusCode: number;
  Response: ApiResponseItem<MenuTailFullModel>;
}

export interface UpdateMenuTailResponse {
  Status: number;
  StatusCode: number;
  Response: ApiResponseItem<MenuTailFullModel>;
}

export interface UpdateOrdersResponse {
  Status: number;
  StatusCode: number;
}

export interface GrantAccessResponse {
  Status: number;
  StatusCode: number;
}

export interface RevokeAccessResponse {
  Status: number;
  StatusCode: number;
}

export interface DeleteMenuTailResponse {
  Status: number;
  StatusCode: number;
}

export interface GetAccessResponse {
  Status: number;
  StatusCode: number;
  Response: ApiResponseItem<AccessRightsResponse>;
}
